import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, themeMode, zIndex, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import Level from '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { DropdownMenu } from '../DropdownMenu/DropdownMenu.es.js';
import { Checkbox } from '../Checkbox/Checkbox.es.js';

const Item = styled(DropdownMenu.Item)`
    padding-left: ${spacing("xs")};
    padding-right: ${spacing("xs")};
`;
const Footer = styled(Level)`
    padding: 0 ${spacing("sm")};
    bottom: 0px;
    overflow: hidden;
    height: 52px;
    margin-bottom: -${spacing("xxs")};
`;
const Header = styled(Box)`
    position: sticky;
    top: 0;
    padding-top: ${spacing("xxs")};
    background-color: ${themeMode({ light: palette("neutral.0"), dark: palette("neutral.800") })};
    z-index: ${zIndex("overlay")};
`;
const FilterDropdownCheckbox = styled(Checkbox)`
    pointer-events: none;
`;

export { FilterDropdownCheckbox, Footer, Header, Item };
//# sourceMappingURL=styled.es.js.map
